import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { AuthContext } from '../App';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', form);
      login(data);
      navigate('/dashboard');
    } catch (e) {
      setError(e.response?.data?.error || 'התחברות נכשלה');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-title">📈 InvestTrack</div>
        <div className="auth-sub">ברוך הבא — התחבר לחשבונך</div>
        {error && <div className="error-msg">{error}</div>}
        <form onSubmit={submit}>
          <div className="form-group">
            <label className="form-label">שם משתמש</label>
            <input className="form-input" value={form.username} onChange={e => setForm({...form, username: e.target.value})} required autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label">סיסמה</label>
            <input className="form-input" type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
          </div>
          <button className="btn btn-primary" style={{width:'100%', justifyContent:'center'}} disabled={loading}>
            {loading ? 'מתחבר...' : 'כניסה'}
          </button>
        </form>
        <div className="auth-footer">
          אין לך חשבון? <a onClick={() => navigate('/register')}>הירשם</a>
        </div>
      </div>
    </div>
  );
}
